/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NzbnCompanyResponseListBaseResponse as ModelsCustomerNzbnCompanyResponseListBaseResponse } from '../../models/Models/Customer/nzbn-company-response-list-base-response';

export interface V3CompaniesNzbnGet$Plain$Params {
  nzbn: string;
}

export function v3CompaniesNzbnGet$Plain(http: HttpClient, rootUrl: string, params: V3CompaniesNzbnGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyResponseListBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3CompaniesNzbnGet$Plain.PATH, 'get');
  if (params) {
    rb.path('nzbn', params.nzbn, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerNzbnCompanyResponseListBaseResponse>;
    })
  );
}

v3CompaniesNzbnGet$Plain.PATH = '/v3/companies/{nzbn}';
